import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import Reveal from '@/components/Reveal';
import SEO from '@/components/SEO';
import ArticleCard from '@/components/ArticleCard';
import { SectionLabel, PrimaryButton } from '@/components/Button';
import { INSIGHT_META } from '@/data/insights';

export default function Insights() {
  const { t } = useTranslation(['insights', 'common']);

  return (
    <Layout>
      <SEO title={t('seo.title')} description={t('seo.description')} />

      <section className="pt-32 md:pt-40 pb-16" data-testid="insights-hero">
        <div className="max-w-content mx-auto px-6 md:px-8 max-w-4xl">
          <Reveal>
            <SectionLabel>{t('hero.eyebrow')}</SectionLabel>
            <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-[60px] font-semibold text-brand-primary leading-[1.06] tracking-tight">
              {t('hero.headline')}
            </h1>
            <p className="mt-7 text-[17px] md:text-lg text-brand-text leading-[1.8] max-w-[72ch]">
              {t('hero.body')}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-10 md:py-16" data-testid="insights-grid">
        <div className="max-w-content mx-auto px-6 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12 items-stretch">
            {INSIGHT_META.map((m, i) => (
              <Reveal key={m.slug} delay={(i % 3) * 0.05}>
                <ArticleCard meta={m} testIdPrefix="insights-card" />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" data-testid="insights-cta">
        <div className="max-w-content mx-auto px-6 md:px-8 max-w-3xl">
          <Reveal>
            <SectionLabel>{t('cta.label')}</SectionLabel>
            <h2 className="mt-5 font-display text-3xl md:text-[44px] font-semibold text-brand-primary leading-tight tracking-tight">
              {t('cta.headline')}
            </h2>
            <p className="mt-6 text-[17px] text-brand-text leading-[1.8] max-w-[68ch]">{t('cta.body')}</p>
            <div className="mt-10">
              <PrimaryButton to="/contact" testId="insights-cta-button">{t('cta.startConversation', { ns: 'common' })}</PrimaryButton>
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
